import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78256530"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-footer" }
const _hoisted_2 = ["src"]

import { computed, ref, h, onMounted } from 'vue';
import { FormInstance, FormRules, ElAlert, ElMessageBox, UploadProps } from 'element-plus';
import { EMessage } from '@aciga/e-ui-next';
import { createOrUpdateProject } from '@/api/project';
import EDrawer from '@/components/bussiness/e-drawer/index.vue';
import { getCheckUpload } from '@/utils';
import { customRequest } from '@/utils/customRequest';
import { useUserStore } from '@/store';
import AutotrimInput from '@/components/autotrim-input/AutotrimInput.vue';

interface Props {
  drawerVisible: boolean;
  projectInfo?: Project.ProjectItem;
  type: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'editProjectDrawer',
  props: {
    drawerVisible: { type: Boolean, default: false },
    projectInfo: { default: () => ({
    projectId: '系统生成，不可修改',
    projectName: '',
    projectEngName: '',
    icon: '',
    projectUrl: '',
    order: 0,
    projectDesc: '',
    sid: null
  }) },
    type: { default: 'create' }
  },
  emits: ['update:drawerVisible', 'on-success'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();
const props = __props;
const emit = __emit;

const drawerShow = computed({
  get: () => props.drawerVisible,
  set: (val) => {
    emit('update:drawerVisible', val);
  }
});

const formRef = ref<FormInstance>();

const iconArr = ref<any[]>([]);
const formData = ref<Project.ProjectItem>({
  projectId: '系统生成，不可修改',
  projectName: '',
  projectEngName: '',
  icon: '',
  projectUrl: '',
  order: 0,
  projectDesc: '',
  sid: null
});

const formRules = ref<FormRules>({
  projectName: [{ required: true, message: '请输入项目名称', trigger: ['blur', 'change'] }],
  projectUrl: [{ required: true, message: '请输入项目地址', trigger: ['blur', 'change'] }],
  order: [{ required: true, message: '请输入项目排序', trigger: ['blur', 'change'] }],
  icon: [{ required: true, message: '请输入icon地址', trigger: ['blur', 'change'] }],
  sid: [{ required: true, message: '请选择所属系统', trigger: ['blur', 'change'] }],
  projectEngName: [
    {
      validator(_rule, value, callback) {
        if (/[\u4e00-\u9fa5]+/.test(value) === false) {
          // 校验通过
          callback();
        } else {
          callback(new Error('禁止输入中文'));
        }
      },
      trigger: 'blur'
    }
  ]
});

// 系统下拉选列表
const sysList = ref<any>([]);

onMounted(() => {
  const { projectInfo } = props;
  if (projectInfo.icon) {
    iconArr.value = [{ name: '', url: projectInfo.icon }];
  }
  formData.value = projectInfo;
  userStore.systemList().then((res) => {
    sysList.value = res;
  });
});

const checkUploadImage = getCheckUpload({
  // 允许的上传格式 例如-['image/jpeg', 'image/jpg', 'image/png']
  allowType: ['image/png'],
  // 类型不匹配错误提示
  typeErrorMessage: '上传图片只能是PNG格式',
  // 大小限制 MB 级别
  sizeLimit: (1 / 1024) * 100,
  // 大小不匹配错误提示
  sizeErrorMessage: '图片大小不能超过100K',
  type: 'image',
  // 图片则可能有宽度限制， 无穷小：-Infinity；无穷大: Infinity [800, Infinity]
  widthLimit: [20, Infinity],
  // 图片则可能有高度限制
  heightLimit: [20, Infinity],
  // 宽高不匹配错误提示
  widthHeightErrorMessage: '图片尺寸宽高>=20*20px'
});

const uploadProjectIconSuccess = (response: string) => {
  formData.value.icon = response;
  iconArr.value = [{ name: '', url: response }];
  if (formRef.value) {
    formRef.value.clearValidate('icon');
  }
};

const uploadProjectIconError = () => {
  formData.value.icon = '';
  iconArr.value = [];
};

const delProjectIcon = () => {
  formData.value.icon = '';
  iconArr.value = [];
};
const onCancel = () => {
  // @ts-ignore
  ElMessageBox.confirm(
    h(ElAlert, {
      title: props.type === 'create' ? '确认取消创建' : '确认取消编辑',
      type: 'warning',
      showIcon: true,
      closable: false
    }),
    props.type === 'create' ? '取消创建项目' : '取消编辑项目',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      customClass: 'e-message-box e-theme-cm',
      confirmButtonClass: 'e-button el-button--main e-theme-cm',
      cancelButtonClass: 'e-button el-button--secondary e-theme-cm',
      effect: 'cm'
    }
  ).then(async () => {
    drawerShow.value = false;
  });
};

const saveLoading = ref(false);
const saveOrUpdate = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      saveLoading.value = true;
      delete formData.value.createTime;
      // create
      if (props.type === 'create') {
        delete formData.value.projectId;
      }

      try {
        const res = await createOrUpdateProject(formData.value);
        const { code } = res || {};
        if (`${code}` === '0') {
          EMessage.success('保存成功');
          drawerShow.value = false;
          emit('on-success');
        }
        saveLoading.value = false;
      } catch (err) {
        saveLoading.value = false;
      }
    }
  });
};

// 图片预览
const dialogImageUrl = ref('');
const dialogVisible = ref(false);

const handlePreview: UploadProps['onPreview'] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!;
  dialogVisible.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_e_option = _resolveComponent("e-option")!
  const _component_e_select = _resolveComponent("e-select")!
  const _component_e_typography = _resolveComponent("e-typography")!
  const _component_e_upload = _resolveComponent("e-upload")!
  const _component_e_input_number = _resolveComponent("e-input-number")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_e_button = _resolveComponent("e-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EDrawer, {
      modelValue: drawerShow.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((drawerShow).value = $event)),
      direction: "rtl",
      title: _ctx.type === 'create' ? '添加项目' : '编辑项目',
      size: "45%",
      "show-footer": true,
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.type === 'create')
            ? (_openBlock(), _createBlock(_component_e_button, {
                key: 0,
                loading: saveLoading.value,
                type: "main",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (saveOrUpdate(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("创建")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          (_ctx.type !== 'create')
            ? (_openBlock(), _createBlock(_component_e_button, {
                key: 1,
                loading: saveLoading.value,
                type: "main",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (saveOrUpdate(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true),
          _createVNode(_component_e_button, {
            type: "secondary",
            onClick: onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_e_form, {
          ref_key: "formRef",
          ref: formRef,
          rules: formRules.value,
          model: formData.value,
          "label-width": "100px",
          "label-position": "right",
          "show-ellipsis": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_e_form_item, {
              label: "项目ID",
              prop: "projectId"
            }, {
              default: _withCtx(() => [
                _createVNode(AutotrimInput, {
                  modelValue: formData.value.projectId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.projectId) = $event)),
                  placeholder: "请输入项目ID",
                  disabled: "",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, {
              label: "项目名称",
              prop: "projectName"
            }, {
              default: _withCtx(() => [
                _createVNode(AutotrimInput, {
                  modelValue: formData.value.projectName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.projectName) = $event)),
                  placeholder: "请输入项目名称",
                  clearable: "",
                  maxlength: 50
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, {
              label: "英文名称",
              prop: "projectEngName"
            }, {
              default: _withCtx(() => [
                _createVNode(AutotrimInput, {
                  modelValue: formData.value.projectEngName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.projectEngName) = $event)),
                  placeholder: "请输入英文名称",
                  clearable: "",
                  maxlength: 50
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, {
              label: "所属系统",
              prop: "sid"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_select, {
                  modelValue: formData.value.sid,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.sid) = $event)),
                  placeholder: "请选择所属系统",
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sysList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_e_option, {
                        key: item.sid,
                        value: item.sid,
                        label: item.sysName
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, {
              label: "icon",
              prop: "icon"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_upload, {
                  "file-list": iconArr.value,
                  "before-upload": _unref(checkUploadImage),
                  "on-success": uploadProjectIconSuccess,
                  "on-error": uploadProjectIconError,
                  "before-remove": delProjectIcon,
                  "on-preview": handlePreview,
                  accept: ".png",
                  class: _normalizeClass({
            hide_card: iconArr.value.length === 1
          }),
                  "http-request": _unref(customRequest),
                  "list-type": "picture-card"
                }, {
                  tip: _withCtx(() => [
                    _createVNode(_component_e_typography, {
                      heading: "5",
                      class: "image-desc",
                      type: "placeholder"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 支持PNG,大小不超过100K,图片尺寸宽高>=20*20px ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "before-upload", "class", "http-request"])
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, {
              label: "项目排序",
              prop: "order"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_e_input_number, {
                  modelValue: formData.value.order,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.order) = $event)),
                  placeholder: "请输入项目排序",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, {
              label: "项目地址",
              prop: "projectUrl"
            }, {
              default: _withCtx(() => [
                _createVNode(AutotrimInput, {
                  modelValue: formData.value.projectUrl,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.projectUrl) = $event)),
                  placeholder: "请输入项目地址",
                  clearable: "",
                  maxlength: 100
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_e_form_item, {
              label: "项目简介",
              prop: "projectDesc"
            }, {
              default: _withCtx(() => [
                _createVNode(AutotrimInput, {
                  modelValue: formData.value.projectDesc,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.projectDesc) = $event)),
                  type: "textarea",
                  maxlength: 100,
                  style: {"max-width":"400px"},
                  "show-word-limit": "",
                  placeholder: "请输入项目简介",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: dialogImageUrl.value,
          class: "preview-image",
          alt: "Preview Image"
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})